export default [  
  {
    path: '/companies',
    name: 'companies',
    component: () => import('@/views/modules/companies/list'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Companies List',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Companies' }
      ]
    },
  },
  {
    path: '/companies/create',
    name: 'companies-create',
    component: () => import('@/views/modules/companies/create'),
    meta: {     
      requiresAuth: true,
      layout: 'app',
      title:'Company Create',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Companies',  to: { name: "companies" } },
        { text: 'Create' }
      ]
    }
  },
  {
    path: '/companies/:id/edit',
    props: true,
    name: 'companies-edit',
    component: () => import('@/views/modules/companies/edit'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Company Edit',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Company',  to: { name: "companies-show" }, param: 'id' },
        { text: 'Edit' }
      ]
    }
  },
  {
    path: '/companies/:id/show',
    props: true,
    name: 'companies-show',
    component: () => import('@/views/modules/companies/show'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Company Details',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Companies',  to: { name: "companies" } },
        { text: 'Details' }
      ]
    }
  },
 
]